/**
 *  Register.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

// redux
import { connect } from "react-redux";

// components
import { Card } from "../../components/Card/Card.jsx";
import DangerZoneList from "./DangerZoneList.jsx";
import Loading from "../Loader/Loader.jsx";

// notifications
import NotificationSystem from "react-notification-system";

// style
import "./style.css";
import { style } from "../../variables/Variables.jsx";

import PolygonMapComponent from "../../components/PolygonMap";
// global
var firebase = require("../../firebase");
var utils = require("../../utils");

class DangerZone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      name: "",
      coordinates: [],
      meetingLat: "",
      meetingLong: "",
      _notificationSystem: null,
      list: [],
    };
  }

  componentDidMount() {
    document.title = "Security Care | Área Sinistro";
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    this.reloadData();
  }

  handlePolygonComplete = (area) => {
    console.log("coordinates", area);
    this.setState({ coordinates: area });
  };

  reloadData = () => {
    this.setState({ loading: true });
    firebase.database
      .ref("dangerZone")
      .orderByChild("createdAt")
      .once("value")
      .then((snap) => {
        let list = [];
        const values = snap.val();
        for (let key in values) {
          let value = values[key];
          value["key"] = key;
          if (value.status > 0) {
            list.unshift(value);
          }
        }
        this.setState({ list, loading: false });
      });
  };

  createNew = (_) => {
    const { name, coordinates, meetingLat, meetingLong } = this.state;
    if (name && coordinates && coordinates && meetingLat && meetingLong) {
      if (
        coordinates.length === 0 ||
        !coordinates[0] ||
        isNaN(Number(coordinates[0].lat)) ||
        isNaN(Number(coordinates[0].lng))
      ) {
        console.log("coordinates-error", coordinates);
        this.notify(
          "Coordenadas inválidas, reinicie o mapa e tente novamente.",
          "error"
        );
      } else if (isNaN(Number(meetingLat))) {
        this.notify("Latitude de encontro inválida", "error");
      } else if (isNaN(Number(meetingLong))) {
        this.notify("Longitude de encontro inválida", "error");
      } else {
        this.setState({ loading: true });
        firebase.database
          .ref("dangerZone")
          .push({
            createdAt: new Date().getTime(),
            status: 1,
            name,
            coordinates,
            meetingLat: Number(meetingLat),
            meetingLong: Number(meetingLong),
          })
          .then((_) => {
            this.setState({
              name: "",
              coordinates: [],
              meetingLat: "",
              meetingLong: "",
            });
            this.notify("Área cadastrada com sucesso", "success");
            this.reloadData();
          });
      }
    } else {
      this.notify("Favor preencher todos os dados", "error");
    }
  };

  handleChange = (evt) => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const { name, meetingLat, meetingLong, list, loading } = this.state;
    console.log({ list });

    return (
      <div className="content bg-content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <PolygonMapComponent
          handlePolygonComplete={this.handlePolygonComplete}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={
            <div style={{ height: `500px`, marginBottom: 60 }} />
          }
          mapElement={<div style={{ height: `100%` }} />}
        />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <div>
                    <fieldset>
                      <legend>CADASTRAR ÁREA DO SINISTRO</legend>
                      <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Nome
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Informe o nome"
                              name="name"
                              value={name}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col>

                      {/* <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Latitude
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Informe a latitude"
                              name="lat"
                              value={lat}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col> */}

                      {/* <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Longitude
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Informe a longitude"
                              name="long"
                              value={long}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Raio (metros)
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Raio em metros"
                              name="radius"
                              value={radius}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col> */}
                    </fieldset>
                    <fieldset>
                      <legend>PONTO DE ENCONTRO PARA ROTA DE FUGA</legend>

                      <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Latitude
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Informe a latitude"
                              name="meetingLat"
                              value={meetingLat}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="form-group">
                          <FormGroup controlId="formControlsTextarea">
                            <ControlLabel style={{ fontWeight: "bold" }}>
                              Longitude
                            </ControlLabel>
                            <FormControl
                              componentClass="input"
                              placeholder="Informe a longitude"
                              name="meetingLong"
                              value={meetingLong}
                              onChange={this.handleChange}
                            />
                          </FormGroup>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div class="form-group">
                          <br></br>
                          <button
                            type="button"
                            class="btn btn-info labelless"
                            style={{ fontWeight: "bold" }}
                            onClick={this.createNew}
                          >
                            <span class="glyphicon glyphicon-plus"></span>{" "}
                            CADASTRAR
                          </button>
                        </div>
                      </Col>
                    </fieldset>
                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {loading ? (
                <Loading />
              ) : (
                <DangerZoneList list={list} reload={this.reloadData} />
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  users: store.users.users,
});

export default connect(mapStateToProps)(DangerZone);



// WEBPACK FOOTER //
// ./src/views/DangerZone/DangerZone.jsx